import type { StaticSharedField } from './types';
import { useSelector } from 'react-redux';

import {
  ERR_TYPE_NUM_LARGE,
  ERR_TYPE_NUM_SMALL,
  ERR_TYPE_REQUIRED,
  FIELD_TYPE_NUMBER,
} from '/business/shared/components/questions/helper/fieldEnums';

import getApplicationCurrencySelector from '/business/shared/state/selectors/application/offset/getApplicationCurrencySelector';
import getAppLanguageSelector from '/business/shared/state/selectors/language/getAppLanguageSelector';
import getCurrencySymbol from '/shared/functions/getCurrencySymbol';

export default function useMakeTotalSpend(): StaticSharedField {
  const currencyCode = useSelector(getApplicationCurrencySelector);
  const userLang = useSelector(getAppLanguageSelector);
  const currencySymbol = getCurrencySymbol({ currencyCode, userLang });

  return {
    type: FIELD_TYPE_NUMBER,
    propName: 'total_spend',
    element: 'total_spend',
    placeholderI18nKey: ' ',
    label: 'Total spend',
    dropdown: {
      propName: 'currency_symbol',
      values: [{ name: currencyCode || '', displayName: currencySymbol || '' }],
      dropdownFirst: true,
    },
    validation: [
      {
        rule: ERR_TYPE_REQUIRED,
        errCode: 'ERRNOTOTALSPEND',
        errStr: 'Please enter the total spend for this category',
      },
      {
        rule: ERR_TYPE_NUM_SMALL,
        errCode: 'ERRTOTALSPENDTOOLOW',
        errStr: 'The total spend for this category must be a positive number',
        value: 0,
      },
      {
        rule: ERR_TYPE_NUM_LARGE,
        errCode: 'ERRTOTALSPENDTOOHIGH',
        errStr: 'The total spend for this category is too high',
        value: 9999999,
      },
    ],
  };
}
